import { FILTERS, DEFAULT_FILTER_OPTIONS } from '../../../../../common/filters/constants';
import { getBeginningOfDay } from '../../../../../../constants/helpers/dates';

import { UssdBillingFilters } from './interfaces';

export const initFilters: UssdBillingFilters = {
  [FILTERS.PAGE_SIZE]: DEFAULT_FILTER_OPTIONS.PAGE_SIZE,
  [FILTERS.FROM]: getBeginningOfDay(),
  [FILTERS.TO]: 'now',
  [FILTERS.OPERATOR]: [],
  [FILTERS.OPERATION_ID]: [],
  [FILTERS.SHORTCODE]: [],
  [FILTERS.MSISDN]: [],
  [FILTERS.SESSION_TYPE]: [],
  [FILTERS.SESSION_TAG]: [],
  [FILTERS.SESSION_CLOSE_REASON]: []
};

export const activeFiltersCountMapper = (activeFilters: UssdBillingFilters) => {
  let availableFiltersCount = 0;

  if (activeFilters.operation_id?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.msisdn?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.operator?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.shortcode?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.session_type?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.session_tag?.length > 0) {
    availableFiltersCount += 1;
  }

  if (activeFilters.session_close_reason?.length > 0) {
    availableFiltersCount += 1;
  }

  return availableFiltersCount;
};
